import { W as WuiSelectInput$1, d as defineCustomElement$1 } from './p-m66-Ap9Q.js';

const WuiSelectInput = WuiSelectInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSelectInput, defineCustomElement };
